import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import { cardData } from '../interfaces/CardData'

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      claims: null,
      data: null
    },
    select: {
      user: {
        data: null
      },
      breed: {
        data: null
      },
      dog: {
        id: null,
        data: null
      },
      subs: {
        id: null,
        data: null
      },
      card: cardData,
    }
  },
  getters: {
    user(state){
      return state.user
    },
    _user(state){
      return state.select.user
    },
    _breed(state){
      return state.select.breed
    },
    _dog(state){
      return state.select.dog
    },
    _card(state){
      return state.select.card
    },
    _subs(state){
      return state.select.subs
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_USER_CLAIMS(state, data) {
      state.user.claims = data;
    },
    SET_SEL_USER(state, data) {
      state.select.user.data = data;      
    },
    SET_SEL_BREED(state, data) {
      state.select.breed.data = data;   
    },
    SET_SEL_DOG(state, data) {
      state.select.dog = data;  
    },
    SET_SEL_CARD(state, data) {
      state.select.card = data; 
    },
    SET_SEL_SUBS(state, data) {
      state.select.subs = data; 
    }
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          ...user,
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});